import { css } from 'styled-components';

export const activePopupBackdropCss = css`
  .application-layout > .content {
    > * {
      filter: blur(2px);
      opacity: 0.3;
      pointer-events: none;
    }
  }
`;
